import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { FormattedMessage } from 'react-intl';

import styles from '@components/auth/Footer.module.css';
import ActionIconButton from '@components/buttons/ActionIconButton';
import Hyperlink from '@components/typography/Hyperlink';
import useMyClient from '@hooks/useMyClient';

const Footer = () => {
  const myClient = useMyClient();

  return (
    <div className={styles.footer + ' contentSpacing'}>
      <IonGrid>
        <IonRow className="ion-justify-content-center">
          {myClient && (
            <IonCol size="auto">
              <Hyperlink className={styles.footerItem} routerLink="/sign-out">
                <FormattedMessage id="menus.client.signOut" />
              </Hyperlink>
            </IonCol>
          )}

          <IonCol size="auto">
            <Hyperlink className={styles.footerItem} href="https://www.withgrayce.com/faq">
              <FormattedMessage id="menus.client.faq" />
            </Hyperlink>
          </IonCol>

          <IonCol size="auto">
            <Hyperlink className={styles.footerItem} href="mailto: support@withgrayce.com">
              <FormattedMessage id="menus.client.getInTouch" />
            </Hyperlink>
          </IonCol>

          <IonCol size="auto">
            <Hyperlink className={styles.footerItem} href="https://www.withgrayce.com/privacy">
              <FormattedMessage id="menus.client.privacy" />
            </Hyperlink>
          </IonCol>

          <IonCol size="auto">
            <Hyperlink className={styles.footerItem} href="https://www.withgrayce.com/terms">
              <FormattedMessage id="menus.client.termsOfUse" />
            </Hyperlink>
          </IonCol>

          <IonCol size="auto">
            <Hyperlink className={styles.footerItem} routerLink="/cookie-policy">
              <FormattedMessage id="menus.client.cookiePolicy" />
            </Hyperlink>
          </IonCol>
        </IonRow>
        <IonRow className="ion-justify-content-center">
          <IonCol size="auto">
            <div className={styles.socialLinks}>
              <ActionIconButton
                ariaLabelKey="dictionary.twitter"
                href="https://twitter.com/AgeWithGrayce/"
                icon={'twitter'}
              />
              <ActionIconButton
                ariaLabelKey="dictionary.facebook"
                href="https://www.facebook.com/WithGrayce/"
                icon={'facebookF'}
              />
              <ActionIconButton
                ariaLabelKey="dictionary.linkedIn"
                href="https://linkedin.com/company/grayceinc/"
                icon={'linkedinIn'}
              />
            </div>
          </IonCol>
        </IonRow>
        <IonRow className="ion-justify-content-center">
          <IonCol size="auto">
            <div className={styles.copyright}>
              <FormattedMessage id="menus.copyright" values={{ year: new Date().getFullYear() }} />
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};

export default Footer;
